import {useUserAuthenticated} from "~/auth/hooks";
import React, {useMemo} from "react";
import {SignInDialogFullscreen} from "~/auth/components/SignInDialogFullscreen/SignInDialogFullscreen";
import {
    ForbiddenAndUnavailableServiceErrorHandlerProvider
} from "~/components/ErrorHandling/ForbiddenAndUnavailableServiceErrorHandlerProvider";
import {TitleAppBar} from "~/ui/AppBar/TitleAppBar";
import {useHistory} from "react-router-dom";
import {goBackUntil} from "~/lib/history";


export type AccessRequiredProps = {
    title: string
    children?: any
}


export const AccessRequired = (props: AccessRequiredProps) => {
    const {children, title} = props;
    const history = useHistory();
    const authenticated = useUserAuthenticated();

    return useMemo(() => {
        const handleSignInClose = () => {
            goBackUntil(history, location => {
                return location.pathname != "/";
            }).catch(console.error);
        }

        const handleBack = () => {
            history.goBack();
        }

        return (
            <>
                <ForbiddenAndUnavailableServiceErrorHandlerProvider
                    appBar={(
                        <TitleAppBar onBack={handleBack} title={title}/>
                    )}
                >
                    <SignInDialogFullscreen open={!authenticated} onClose={handleSignInClose}/>
                    {authenticated && children}
                </ForbiddenAndUnavailableServiceErrorHandlerProvider>
            </>
        );
    }, [authenticated, children, title]);
}